"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentLang = void 0;
var useI18nService_1 = require("./useI18nService");
var useCurrentLang = function () {
    var i18nService = useI18nService_1.useI18nService();
    return i18nService.lng;
};
exports.useCurrentLang = useCurrentLang;
